export enum DirectoryModalID {
    DirectoryDetails
}
